import React from "react"

type CaptionTextProps = {
  highlightedWords?: string[]
  text: string
  redactedWords: string[]
}

const escapeRegExp = (value: string) =>
  value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")

const CaptionText: React.FC<CaptionTextProps> = ({
  highlightedWords = [],
  text,
  redactedWords,
}) => {
  const matches = [...redactedWords, ...highlightedWords].sort(
    (first, second) => second.length - first.length
  )

  if (matches.length === 0) return <>{text}</>

  const matchPattern = new RegExp(
    `(^|[^A-Za-z0-9_])(${matches
      .map(escapeRegExp)
      .join("|")})(?=$|[^A-Za-z0-9_])`,
    "gi"
  )
  const parts: React.ReactNode[] = []
  let lastIndex = 0
  let match: RegExpExecArray | null

  while ((match = matchPattern.exec(text)) !== null) {
    const wordStart = match.index + match[1].length
    const wordEnd = wordStart + match[2].length

    parts.push(text.slice(lastIndex, wordStart))
    const matchedText = text.slice(wordStart, wordEnd)
    const isRedacted = redactedWords.some(
      redactedWord => redactedWord.toLowerCase() === matchedText.toLowerCase()
    )

    if (isRedacted) {
      parts.push(
        <span key={wordStart} className="bg-white text-white">
          {matchedText.replace(/./g, "-")}
        </span>
      )
    } else {
      parts.push(
        <strong key={wordStart} className="font-bold text-sky-300">
          {matchedText}
        </strong>
      )
    }
    lastIndex = wordEnd
  }

  parts.push(text.slice(lastIndex))

  return <>{parts}</>
}

export default CaptionText
